import React from 'react';
import resources from '../../resources';
import { Row, Col } from 'antd';
import languages from '../../appdata/languages';
import StoreManager from '../../appdata';
import StatItem4 from '../BaseComponents/StatItem4';

class Zalopay2024Content extends React.Component {
  render() {
    const lg = StoreManager.appState.thisApp.state.currentLanguage
    const lang = languages[StoreManager.appState.thisApp.state.currentLanguage].Zalopay2024Content;
    const {isMobile} = StoreManager.appState.thisApp.state

    return (
      <div style={{ lineHeight: 1.6 }}>
        <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 600 }}>{lang.title}</h2>

        {lang.intro.map((p, i) => (
          <p key={i} style={{ marginTop: i === 0 ? 24 : 0 }}>{p}</p>
        ))}

        {/* Stats */}
        <Row gutter={[12, 24]} style={{ marginTop: 24, marginBottom: 48 }}>
          {lang.stats.map((item, index) => (
            <Col
              key={index}
              xs={24}
              md={index === 4 ? 24 : 12}
            >
               <StatItem4
              iconName={item.icon}
              value={item.value}
              message1={item.unit}
            />
              {/* <div
                style={{
                  backgroundColor: '#EDF8FF',
                  borderRadius: 16,
                  padding: 24,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 16,
                }}
              >
                <img src={resources.icons[item.icon]} alt="icon" style={{ width: 40, height: 40 }} />
                <div>
                  <div style={{ fontWeight: 600, fontSize: 28, color: '#F15A24' }}>{item.value}</div>
                  <div style={{ fontWeight: 500 }}>{item.unit}</div>
                </div>
              </div> */}
            </Col>
          ))}
        </Row>

        {/* QR Section */}
        <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.qrTitle}</h4>
        {lang.qrParagraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
        <img src={resources.images.Zalopay2024Image1} alt="QR Code Demo" style={{ width: '100%', borderRadius: 16, margin: '24px 0' }} />

        {/* Financial Inclusion */}
        <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.financeTitle}</h4>
        <p>{lang.financeParagraph}</p>
        <ul style={{ paddingLeft: 20, lineHeight: 1.8 }}>
          {lang.financeList.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
        <img src={lg == 'vi' ?resources.images.Zalopay2024Image2_vi :resources.images.Zalopay2024Image2} alt="Finance Services" style={{ width: '100%', borderRadius: 16, margin: '24px 0' }} />

        {/* Social Impact */}
        <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.impactTitle}</h4>
        <p>{lang.impactIntro}</p>
        <ul style={{ paddingLeft: 20, lineHeight: 1.8 }}>
          {lang.impactList.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
        <Row gutter={[16, 16]} style={{ marginTop: 24, marginBottom: 32 }}>
          <Col xs={24} md={12}><img src={resources.images.Zalopay2024Image3} alt="Gift Drive" style={{ width: '100%', borderRadius: 12 }} /></Col>
          <Col xs={24} md={12}><img src={resources.images.Zalopay2024Image4} alt="Spring Journey QR" style={{ width: '100%', borderRadius: 12 }} /></Col>
        </Row>

        {/* Culture */}
        <h4 style={{ fontSize: 16, fontWeight: 600, marginTop: 48 }}>{lang.cultureTitle}</h4>
        <p>{lang.cultureIntro}</p>
        <ul style={{ paddingLeft: 20, lineHeight: 1.8 }}>
          {lang.cultureList.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
        <p style={{ marginTop: 12 }}>{lang.cultureOutro}</p>

        {/* Outlook */}
        <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.outlookTitle}</h4>
        <p>{lang.outlookIntro}</p>
        <ul style={{ paddingLeft: 20, lineHeight: 1.8 }}>
          {lang.outlookList.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
        <p>{lang.outlookClosing}</p>
      </div>
    );
  }
}

export default Zalopay2024Content;
